<aside class="w-[215px] min-w-[215px] bg-white border-r border-gray-200 flex flex-col overflow-y-auto">
  <div class="px-4 pt-5 pb-4 border-b border-gray-200">
    <span class="block text-lg font-bold text-gray-900 leading-tight">Watch Tower</span>
    <span class="block text-[11px] text-gray-400 mt-0.5">watchtower.boemm.eu</span>
  </div>

  <nav class="p-2 flex flex-col gap-0.5">
    <a
      routerLink="/index"
      routerLinkActive
      #indexLink="routerLinkActive"
      class="flex items-center px-3 py-2 rounded-lg text-sm no-underline transition-colors"
      [ngClass]="indexLink.isActive ? 'bg-violet-100 text-violet-800 font-medium' : 'text-gray-700 hover:bg-gray-100'"
    >
      Index
    </a>

    <a
      routerLink="/execute"
      routerLinkActive
      #executeLink="routerLinkActive"
      class="flex items-center px-3 py-2 rounded-lg text-sm no-underline transition-colors"
      [ngClass]="executeLink.isActive ? 'bg-violet-100 text-violet-800 font-medium' : 'text-gray-700 hover:bg-gray-100'"
    >
      Execute
    </a>

    <a
      routerLink="/history"
      routerLinkActive
      #historyLink="routerLinkActive"
      class="flex items-center px-3 py-2 rounded-lg text-sm no-underline transition-colors"
      [ngClass]="historyLink.isActive ? 'bg-violet-100 text-violet-800 font-medium' : 'text-gray-700 hover:bg-gray-100'"
    >
      History
    </a>
  </nav>
</aside>
